import "./style.css";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { Toaster } from "./components/ui/sonner";

const root = ReactDOM.createRoot(document.querySelector("#root"));

root.render(
  <>
    <Toaster />
    <App />
  </>
);
